module.exports = __webpack_public_path__ + "sunsemweb/img/map.7391ad49.png";